import React from 'react';
import { Link } from 'react-router-dom';
import './Location.css';

const Location = () => {
  return (
    <section className="location-section">
      <h2 className="location-title">Our location</h2>
      <div className="location-container">
        <div className="map-container">
          <iframe
            title="Highlands' Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.6893775837584!2d-122.26238668968809!3d37.50297597205764!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fa3a4fd8f6b27%3A0x7296356f8f659a2e!2s644%20Laurel%20St%2C%20San%20Carlos%2C%20CA%2094070!5e0!3m2!1sen!2sus!4v1710901234567!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <div className="location-info">
          <div className="location-header">
            <div className="header-content">
              <h3>Highlands Sports Bar & Grill</h3>
              <p>San Carlos, CA</p>
            </div>
            <a 
              href="https://www.google.com/maps/dir/?api=1&destination=644%20Laurel%20St%2C%20San%20Carlos%2C%20CA%2094070%2C%20USA" 
              className="get-directions"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Directions →
            </a>
          </div>
          <div className="location-meta">
            <div className="meta-group">
              <h4>ADDRESS</h4>
              <p>644 Laurel Street Suite C</p>
              <p>San Carlos, CA 94070</p>
            </div>
            <div className="meta-group">
              <h4>CONTACTS</h4>
            </div>
          </div>
          <div className="location-hours">
            <Link to="/menu" className="see-hours">See hours →</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location; 